module.exports = __webpack_public_path__ + "DINNextLTPro-UltraLightIt.eot?16f2ca1aa771fe93ef27b0c82e8e406d";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/DINNextLTPro-UltraLightIt.eot
// module id = 308
// module chunks = 0